/** Top Charts 筛选器 hover 文案 formatMessage 类型 */
export type TTopChartsFilterTipsFormatMessage = (
  descriptor: { id: string },
) => string;

/**
 * 按 filterKey → localeId 映射批量生成 filterTips。
 */
export const buildFilterTips = (
  formatMessage: TTopChartsFilterTipsFormatMessage,
  localeKeyMap: Record<string, string>,
): Record<string, string> => {
  const tips: Record<string, string> = {};
  Object.entries(localeKeyMap).forEach(([filterKey, localeId]) => {
    tips[filterKey] = formatMessage({ id: localeId });
  });
  return tips;
};

/**
 * 将标签组等扩展映射合并进已有 filterTips（原地修改并返回）。
 */
export const mergeFilterTips = (
  tips: Record<string, string>,
  formatMessage: TTopChartsFilterTipsFormatMessage,
  localeKeyMap: Record<string, string>,
  filterKeys: readonly string[],
): Record<string, string> => {
  filterKeys.forEach((key) => {
    const localeId = localeKeyMap[key];
    if (localeId) {
      tips[key] = formatMessage({ id: localeId });
    }
  });
  return tips;
};

/**
 * 将 filterTips 按 item.key 注入 inputList 的 hoverTip。
 * TopCharts CommonFilter 与模块通用 CommonFilter 共用。
 */
export const applyFilterTipsToInputList = (
  inputList: any[],
  filterTips?: Record<string, unknown>,
): any[] => {
  if (!filterTips || typeof filterTips !== 'object') {
    return inputList;
  }

  return inputList?.map((item: any) => {
    if (!item?.key) {
      return item;
    }
    const tip = filterTips[item.key];
    if (tip === null || tip === undefined) {
      return item;
    }
    return { ...item, hoverTip: tip };
  });
};
